<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M11.7,7C11.9,6.6,12,6,12,5.5C12,5.4,12,5.2,12,5.1C12,5,12,5,12,5C12,4.9,12,4.8,11.9,4.7C11.9,4.7,11.9,4.6,11.9,4.6C11.4,3.1,10.1,2,8.5,2C8.5,2,4,2,4,2C3.5,2,3,2.4,3,3C3,3,3,13,3,13C3,13.5,3.4,14,4,14C4,14,9,14,9,14C11.2,14,13,12.2,13,10C13,8.8,12.5,7.7,11.7,7C11.7,7,11.7,7,11.7,7ZM6,5C6,5,8,5,8,5C8.6,5,9,5.4,9,6C9,6.6,8.6,7,8,7C8,7,6,7,6,7C6,7,6,5,6,5C6,5,6,5,6,5ZM9,11C9,11,6,11,6,11C6,11,6,9,6,9C6,9,9,9,9,9C9.6,9,10,9.4,10,10C10,10.6,9.6,11,9,11C9,11,9,11,9,11Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Bold',
} as DefineComponent
</script>
